export const USER_MANAGEMENT_ROUTE_PATH = 'user-management';

/** Router link to the user management page (`/user-management`). */
export const USER_MANAGEMENT_LIST_ROUTE = ['/', USER_MANAGEMENT_ROUTE_PATH] as const;
